import React, { useState, useEffect } from 'react'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { Popover } from '@material-ui/core'
const { makeStyles } = require('@material-ui/core')
import PortalModal, { usePortalModal } from 'components/commons/PortalModal'
import { publishQuestAction } from 'context/reducers/QuestionariesReducer'
import { useStateValue } from 'context/store'
import { getFromApi, postToApi, putToApi } from 'actions'
import { QUESTIONNAIRE } from 'components/Questionnaire/CreateInitalQuestionnaire/constants.js'
import {
   closeSpinnerAction,
   openSpinnerAction
} from 'context/reducers/openSpinnerReducer'
import { openSnackBarAction } from 'context/reducers/openSnackbarReducer'
import {
   formatFinalDateQuestionnaire,
   formatInitialDateQuestionnaire
} from 'utils/utils'

const opciones = ['PUBLICADO', 'INACTIVO', 'BORRADOR']
const color = {
   PUBLICADO: '#37C846',
   PROGRAMADO: '#3264DC',
   INACTIVO: '#FF3A60',
   BORRADOR: '#EF8833'
}
const colorBg = {
   PUBLICADO: '#67AC5B1A',
   PROGRAMADO: '#3264DC1A',
   INACTIVO: '#B000201A',
   BORRADOR: '#EF88331A'
}

function StatusSelect({ data, onSubmitCallback }) {
   const {
      name,
      description,
      subdomainId,
      applicationId,
      roles,
      groups,
      functionality,
      finalDate,
      initialDate
   } = data
   const [{ questionaries = {} }, dispatch] = useStateValue()

   const [anchorEl, setAnchorEl] = useState(null)
   const isOpen = Boolean(anchorEl)
   const id = isOpen ? 'simple-popper' : undefined
   const { params, onClose, setModal } = usePortalModal()
   const [selectOption, setSelecOption] = useState(data.status)
   const handleToggleOpen = event => {
      setAnchorEl(anchorEl ? null : event.currentTarget)
   }

   useEffect(() => {
      setSelecOption(data.status)
   }, [data])

   useEffect(() => {
      if (questionaries) onSubmitCallback()
   }, [questionaries])

   const Styles = makeStyles(theme => ({
      select: {
         position: 'relative'
      },
      selectOptions: {
         '&.MuiPaper-root': {
            display: 'flex',
            flexDirection: 'column'
         }
      },
      options: {
         width: '100%',
         textAlign: 'start',
         padding: '10px',
         position: 'relative',
         '&:hover': {
            background: '#3264DC1A',
            '&::after': {
               content: '""',
               position: 'absolute',
               width: '3px',
               height: '100%',
               background: '#3264DC',
               left: 0,
               top: 0
            }
         }
      },
      selectContainer: {
         background: colorBg[selectOption],
         color: color[selectOption],
         fontWeight: '700',
         height: '30px',
         display: 'flex',
         alignItems: 'center',
         justifyContent: 'center',
         padding: '5px 20px',
         borderRadius: '20px',
         gap: '10px',
         cursor: 'pointer'
      },
      badge: {
         width: '10px',
         height: '10px',
         borderRadius: '100%',
         background: color[selectOption]
      }
   }))
   const publicado = async () => {
      const url = `${process.env.REACT_APP_QUESTIONNAIRE_API}/questionnaire/QuestionnairePublished`
      const payload = {
         questionareId: data.id,
         question: true
      }
      try {
         const res = await postToApi(url, payload)
         await dispatch(publishQuestAction(QUESTIONNAIRE.PUBLISHED_STATUS))
      } catch (error) {
         dispatch(openSnackBarAction(err?.data?.message))
      }
   }
   const inactive = async opcion => {
      try {
         const payload = {
            name,
            description,
            subdomainId,
            applicationId,
            roles,
            groups,
            functionality,
            finalDate: formatFinalDateQuestionnaire(finalDate),
            initialDate: formatInitialDateQuestionnaire(initialDate),
            status: opcion
         }
         const res = await putQuestionnarie(payload)
         await dispatch(publishQuestAction(QUESTIONNAIRE.PUBLISHED_STATUS))
      } catch (err) {
         dispatch(openSnackBarAction(err?.data?.message))
      }
   }

   const classes = Styles()

   const putQuestionnarie = async payload => {
      const URL_QUESTIONNARIE = `${process.env.REACT_APP_QUESTIONNAIRE_API}/questionnaire/${data.id}`
      dispatch(openSpinnerAction())
      try {
         const dataPost = await putToApi(URL_QUESTIONNARIE, payload)
         dispatch({ type: 'SaveQuest', questionaries: dataPost })
         await dispatch(closeSpinnerAction())
         await dispatch(
            openSnackBarAction(
               `Se actualizo correctamente el cuestionario`,
               'Info'
            )
         )
         return dataPost
      } catch (error) {
         dispatch(closeSpinnerAction())
         dispatch(
            openSnackBarAction(
               `Ocurrio un error al intentar actualizar el cuestionario: ${error?.data?.message}`,
               'error'
            )
         )
         console.log(error)
      }
   }
   const setopcion = async opcion => {
      const payload = {
         name,
         description,
         subdomainId,
         applicationId,
         roles,
         groups,
         functionality,
         finalDate: formatFinalDateQuestionnaire(finalDate),
         initialDate: formatInitialDateQuestionnaire(initialDate),
         status: opcion
      }
      if (selectOption == 'BORRADOR' && opcion == 'PUBLICADO') {
         const res = await dispatch(publishQuestAction(data))
      }
      if (selectOption == 'BORRADOR' && opcion == 'INACTIVO') {
         const res = await putQuestionnarie(payload)
         res && setSelecOption(res.status)
      }
      if (selectOption == 'PROGRAMADO' && opcion == 'PUBLICADO') {
         const res = await dispatch(
            publishQuestAction({
               ...data,
               isChange: true,
               statusChange: opcion
            })
         )
      }
      if (selectOption == 'PROGRAMADO' && opcion == 'INACTIVO') {
         const res = await putQuestionnarie(payload)
         res && setSelecOption(res.status)
      }
      if (selectOption == 'PROGRAMADO' && opcion == 'BORRADOR') {
         const res = await putQuestionnarie(payload)
         res && setSelecOption(res.status)
      }
      if (selectOption == 'INACTIVO' && opcion == 'BORRADOR') {
         const res = await putQuestionnarie(payload)
         res && setSelecOption(res?.status)
      }
      if (selectOption == 'INACTIVO' && opcion == 'PUBLICADO') {
         data.message = INACTIVE_TEX
         await dispatch(publishQuestAction(data))
      }

      if (selectOption == 'PUBLICADO' && opcion == 'INACTIVO') {
         setModal({
            message: WARNING_TEX,
            onConfirm: () => inactive(opcion)
         })
      }

      if (selectOption == 'PUBLICADO' && opcion == 'BORRADOR') {
         setModal({
            message: WARNING_TEX,
            onConfirm: () => publicado()
         })
      }
      handleClose()
   }
   const handleClose = () => {
      setAnchorEl(null)
   }

   return (
      <>
         <PortalModal params={params} onClose={onClose} />
         <section className={classes.select}>
            <article
               className={classes.selectContainer}
               aria-describedby={id}
               onClick={handleToggleOpen}
            >
               <div className={classes.badge}></div>
               <span> {selectOption} </span>
               <ExpandMoreIcon />
            </article>
            <Popover
               id={id}
               open={isOpen}
               onClose={handleClose}
               anchorEl={anchorEl}
               class={`${classes.selectOptions}`}
               anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left'
               }}
            >
               {opciones.map(opcion =>
                  selectOption != opcion ? (
                     <div
                        className={classes.options}
                        onClick={() => setopcion(opcion)}
                     >
                        {' '}
                        {opcion}{' '}
                     </div>
                  ) : (
                     ''
                  )
               )}
            </Popover>
         </section>
      </>
   )
}

export default StatusSelect

const WARNING_TEX =
   'Señor usuario, está intentando cambiar el estado de un cuestionario publicado en el aplicativo Mundo Mutual, si usted requiere cambiar el estado se bajará la publicación ¿Desea continuar con la operación?'

const INACTIVE_TEX =
   'Señor usuario, ¿Está intentando publicar un cuestionario en estado inactivo, desea activarlo y realizar la publicación de este cuestionario?'
